"use client";

import React from "react";
import { cn } from "utils";

export interface ChatSignalTagProps {
  label: string;
  /** 更小字号（Earnings Beat 等） */
  compact?: boolean;
  className?: string;
}

/** TA / Earnings 结果等弱标签 */
export const ChatSignalTag: React.FC<ChatSignalTagProps> = ({
  label,
  compact,
  className,
}) => (
  <span
    className={cn(
      "inline-flex rounded-1 bg-background_accent1_overlay20 px-1.5 py-0.5 text-content_accent1_primary",
      compact ? "body_medium_xs px-1 py-0.5" : "body_medium_s",
      className,
    )}
  >
    {label}
  </span>
);
